<template>
  <div class="business-profile" v-if="business">
    <MainBackButton />

    <div
      class="business-name"
      :class="{ 'shop-hidden': isHidden }"
      @click="toggleHidden"
    >
      <i v-if="isHidden" class="far fa-eye-slash fa-sm" />
      {{ business.name }}
    </div>
    <div class="favorite">
      <span
        class="button is-dark shadow is-rounded"
        style="padding: 9px"
        @click="$router.push(`/shop/${businessID}`)"
      >
        <i class="fa fa-external-link-alt wiggle" />
      </span>
    </div>

    <section class="hero has-bg-img" v-webp:bg="bannerPicURL">
      <!-- <span
        class="button is-dark shadow is-rounded camera-btn"
        @click="setBusinessBannerPic"
      >
        <i class="fa fa-camera-retro" />
      </span> -->
      <div class="hero-body"></div>
      <div class="tabs is-fullwidth has-text-weight-medium is-centered">
        <ul>
          <li
            :class="{ selected: tab === 'Information' }"
            @click="setTab('Information')"
          >
            <a>{{ $t("business.information") }}</a>
          </li>
          <li
            :class="{ selected: tab === 'Workflows' }"
            @click="setTab('Workflows')"
          >
            <a>{{ $t("business.workflows") }}</a>
          </li>
        </ul>
      </div>
    </section>

    <figure class="image is-96x96">
      <img v-webp="profilePic" @error="defaultImg" @click="openSetPic" />
      <!-- @click="setBusinessProfilePic" -->
    </figure>

    <input
      type="file"
      ref="file"
      style="display: none"
      accept="image/png,image/jpeg,image/jpg,image/bmp"
      @change="setPicAWS($event)"
    />

    <div
      class="no-scrollbar"
      style="max-height: calc(100vh - 200px); overflow: scroll"
    >
      <BusinessInfoTab ref="info" v-show="tab === 'Information'" />
      <BusinessWorkflowsTab v-show="tab === 'Workflows'" />
    </div>

    <div
      v-if="business.is_deleted && showDeletedBtn"
      class="deleted-bg"
      @click="showDeletedBtn = false"
    >
      <div class="deleted-btn">
        <i>{{ $t("Deleted Business") }}</i>
      </div>
    </div>
  </div>
</template>


<script>
import imageCompression from "browser-image-compression";

import MainBackButton from "@/components/MainBackButton";
import BusinessInfoTab from "@/components/BusinessInfoTab";
import BusinessWorkflowsTab from "@/components/BusinessWorkflowsTab";

export default {
  name: "BusinessProfile",
  components: {
    MainBackButton,
    BusinessInfoTab,
    BusinessWorkflowsTab,
  },
  data() {
    return {
      // tab: "Information", // start on information tab
      tab: "Workflows",
      businessID: null,
      editImageType: null, // banner or profile
      showDeletedBtn: true,
    };
  },
  computed: {
    business() {
      return this.$store.state.selectedBusiness;
    },
    isHidden() {
      return this.business.data.hidden;
    },
    profilePic() {
      if (this.business.profile_pic_url) return this.business.profile_pic_url;
      return "https://i.ibb.co/DK0f6y3/TUK-Esssentials-profile.png"; // ../assets/home_menu_shop.png
    },
    bannerPicURL() {
      if (this.business.banner_pic_url) return this.business.banner_pic_url;
      return `https://www.khaosodenglish.com/wp-content/uploads/2019/02/DSC06061.jpg`;
    },
    // backgroundImage() {
    //   var url = this.bannerPicURL;
    //   return `background-image: linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.74)), url(${url});`;
    // }
  },
  // activated() {
  //   this.init();
  // },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      // check superuser role here in case they don't belong...
      if (!this.isSuperUser()) return this.goHome();

      // this.console("this.$route", this.$route);
      this.businessID = this.$route.params.id; // businessID
      this.console("businessID", this.businessID);

      this.clearURLQuery();
      // if (this.$route.path !== this.$route.fullPath) this.$router.replace(this.$route.path); // clear the query

      this.$store.commit("selectBusiness", this.businessID);

      // if (!this.business) {
      this.$store
        .dispatch("getAndSelectBusiness", this.businessID)
        .catch((err) => this.apiError(err));
      this.$store
        .dispatch("getWorkflows", this.businessID)
        .catch((err) => this.apiError(err));
    },
    openSetPic() {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'><i class='fa fa-image'></i>&nbsp;Set Pics</p>
        <p>Choose which picture you'd like to set:</p>
        </div>`,
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "Logo",
        cancelButtonText: "Banner",
        cancelButtonColor: this.bulmaColor("primary"),
      }).then((val) => {
        if (val.value) this.setBusinessProfilePic();
        if (val.dismiss === "cancel") this.setBusinessBannerPic();
      });
    },
    toggleHidden() {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>Toggle Hidden</p>
        <p>hidden: <b>${this.business.data.hidden}</b></p>
        </div>`,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: "Toggle",
      }).then((val) => {
        if (val.value) this.$refs.info.toggleHidden();
      });
    },
    defaultImg(e) {
      e.target.src = this.$store.state.menuItemPlaceholderPic;
    },
    setTab(tab) {
      if (!this.loginOkay(this.$t("login.login-to-view"))) return;
      this.tab = tab;
    },
    // setTab(e) {
    //   if (this.loginOkay(this.$t("login.login-to-view"))) {
    //     this.$el.querySelectorAll("li").forEach(function (el) {
    //       el.classList.remove("is-active");
    //     });
    //     this.$el.querySelectorAll("li a").forEach(function (el) {
    //       el.classList.remove("has-text-warning");
    //       el.classList.add("has-text-white");
    //     });
    //     e.target.classList.add("is-active");
    //     e.target.classList.add("has-text-warning");
    //     this.tab = e.target.id; // e.target.innerText;
    //   }
    // },
    setBusinessProfilePic() {
      this.editImageType = "profile";
      this.$refs.file.click();
    },
    setBusinessBannerPic() {
      this.editImageType = "banner";
      this.$refs.file.click();
    },
    savePicURL(picURL) {
      var obj = { id: this.business.id };
      var picType = this.editImageType + "_pic_url";
      obj[picType] = picURL;
      this.$store
        .dispatch("updateBusiness", obj)
        .then((res) => {
          this.console("updateBusinessPic success", res);
          this.business[picType] = picURL;
          this.successToast("Success!");
        })
        .catch((err) => this.apiError(err));
    },
    setPicAWS(e) {
      if (!e.target.files) return;
      if (e.target.files.length === 0) return;
      var originalFile = e.target.files[0];

      var loader = this.loadingDots();
      var options = {
        maxSizeMB: 0.3,
        maxWidthOrHeight: 400,
        useWebWorker: true,
      };
      imageCompression(originalFile, options)
        .then((compressedFile) => {
          var sizeKB = Math.round(compressedFile.size / 1024);
          this.console(`compressedFile size ${sizeKB} KB`); // smaller than maxSizeMB

          imageCompression
            .getDataUrlFromFile(compressedFile)
            .then((base64) => {
              var data = {
                name: this.$shortid.generate() + ".png",
                content: base64.replace(/^data:image\/[a-z]+;base64,/, ""),
                businessID: this.business.id,
                imageType: this.editImageType,
              };
              this.$store
                .dispatch("uploadImageAWS", data)
                .then((res) => {
                  console.log("uploadImageAWS", res.data);
                  var newPicURL = res.data.compressed_image_url;
                  this.savePicURL(newPicURL);
                })
                .catch((err) => this.apiError(err))
                .finally(() => loader.hide());
            })
            .catch((err) => this.console("imageData error", err));
        })
        .catch((err) => this.console("imageCompression error", err));
    },
  },
};
</script>

<style scoped>
.business-profile {
  height: 100vh;
  overflow: hidden;
}
.tabs {
  padding-top: 20px;
  background-image: linear-gradient(
    to bottom,
    transparent,
    rgba(0, 0, 0, 0.3) 20%,
    rgba(0, 0, 0, 0.8)
  );
}
.has-bg-img {
  /* background: url("../assets/NYC.jpg") center center; */
  background-color: #2693da;
  background-size: cover;
  background-position: center;
  height: 200px; /* height: 25vh; */
}
figure {
  position: absolute;
  top: 110px;
  left: 50%;
  transform: translate(-50%, -50%);
}
img {
  object-fit: cover;
  height: 96px;
  width: 96px;
  border-radius: 3px;
  /* border: 3px solid gold; */
  /* -webkit-filter: drop-shadow(2px 2px 2px #666); */
  filter: drop-shadow(2px 2px 2px #666);
  border: 1px solid white;
  /* box-shadow: 0 0 0 1.5px #d3d3d4, 2px 2px 3px rgba(0, 0, 0, 0.35); */
}
hr {
  margin: 0 0;
}
.field-name {
  margin-bottom: 0;
  line-height: 0pt;
}
.business-name {
  position: absolute;
  top: 10px;
  left: 55px;
  background-color: rgba(255, 255, 255, 0.7);
  /* font-size: 1.1em; */
  font-weight: 500;
  padding: 0 3px;
  border-radius: 2px;
  box-shadow: 0 0 2px grey;
  text-align: left;
  max-width: calc(100vw - 110px);
}
.shop-hidden {
  background-color: var(--danger) !important;
  color: white;
}
.favorite {
  position: absolute;
  top: 10px;
  right: 10px;
}
.shadow {
  filter: drop-shadow(1px 1px 1px black);
}
.wiggle:active {
  transform: rotate(340deg);
  -webkit-transform: rotate(340deg);
  -ms-transform: rotate(340deg);
}
.camera-btn {
  position: absolute;
  top: 130px;
  right: 10px;
  padding: 8px;
  /* background-color: rgba(255, 255, 255, 0.4); */
}
.clone-btn {
  position: absolute;
  top: 130px;
  left: 10px;
  padding: 8px;
  background-color: rgba(255, 255, 255, 0.4);
}
.button.shadow {
  background-color: rgba(0, 0, 0, 0.2);
}
.deleted-bg {
  position: absolute;
  top: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(255, 0, 0, 0.14);
}
.deleted-btn {
  padding: 12px;
  background-color: red;
  color: white;
  /* margin: auto; */
  width: 50vw;
  top: 50vh;
  position: absolute;
  transform: translate(50%, -50%);
  border-radius: 100px;
  box-shadow: 1px 1px 5px black;
  font-size: 1.8em;
}
li a:hover {
  color: white;
}
li a {
  font-weight: 400;
  color: rgba(255, 255, 255, 0.712);
}
.selected a {
  font-weight: 550;
  color: var(--warning);
}
</style>